import { render, staticRenderFns } from "./without-menu.vue?vue&type=template&id=a473f304&scoped=true&lang=pug&"
import script from "./without-menu.js?vue&type=script&lang=js&"
export * from "./without-menu.js?vue&type=script&lang=js&"
import style0 from "./without-menu.vue?vue&type=style&index=0&id=a473f304&lang=scss&scoped=true&"
import style1 from "./without-menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473f304",
  null
  
)

export default component.exports